<template>
    <Modal :title="isAdd ? '添加售后' : '编辑售后'" :value="value" @on-cancel="close" @on-visible-change="visibleChange" :mask-closable="false" width="500">
        <Form :model="form" :label-width="100" label-position="right" ref="formValidate" :rules="rules">
            <!-- <Row>
                <Col span="20">
                    <FormItem label="姓名：" prop="c名字" v-if="!form.isOutside">
                        <Input type="text" placeholder="请输入" v-model="form.c名字"></Input>
                    </FormItem>
                    <FormItem label="姓名：" prop="userId" v-if="form.isOutside">
                        <Select v-model="form.userId">
                            <Option v-for="item in nameItems" :value="item.value" :key="item.value">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="4">
                    <i-switch v-model="form.isOutside" @on-change="isOutsideChange" size="large" style="position: relative; top: 5px; margin-left: 10px">
                        <span slot="open">内部</span>
                        <span slot="close">外部</span>
                    </i-switch>
                </Col>
            </Row> -->
            <FormItem label="姓名：" prop="name">
                <Input type="text" placeholder="请输入" v-model="form.name"></Input>
            </FormItem>

            <FormItem label="公司：" prop="companyName">
                <Input type="text" placeholder="请输入" v-model="form.companyName"></Input>
            </FormItem>
            <FormItem label="电话：" prop="phoneNumber">
                <Input type="text" placeholder="请输入" v-model="form.phoneNumber"></Input>
            </FormItem>
            <FormItem label="城市：" prop="city">
                <Input type="text" placeholder="请输入" v-model="form.city"></Input>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button @click="close">取消</Button>
            <Button @click="submit" type="primary">确认</Button>
        </div>
    </Modal>
</template>

<script>
import { createOutPerson, updateOutPerson, getOutPersonById } from '../../../../api/index';
export default {
    data() {
        return {
            loading: false,
            form: { name: '', companyName: '', phoneNumber: '', city: '', userName: '', id: null },
            rules: {
                name: [{ required: true, message: '不能为空', trigger: 'change' }],
                companyName: [{ required: false, message: '不能为空', trigger: 'change' }],
                phoneNumber: [{ required: false, message: '不能为空', trigger: 'change' }],
                city: [{ required: false, message: '不能为空', trigger: 'change' }],
                id: [{ required: false, message: '不能为空', trigger: 'change', type: 'number' }],
            },
        };
    },
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        nameItems: {
            type: Array,
            default: [],
        },
        uid: {
            type: [String, Number],
        },
        isAdd: {
            type: Boolean,
            default: true,
        },
    },
    mounted() {},
    methods: {
        // isOutsideChange() {
        //     this.form['c名字'] = '';
        //     this.form['id'] = '';
        // },
        close() {
            this.$emit('close');
            this.clearData();
        },
        visibleChange(value) {
            if (!value) {
                this.$emit('close');
                this.clearData();
            }
        },
        async submit() {
            this.$refs['formValidate'].validate(async valid => {
                if (valid) {
                    if (this.isAdd) {
                        //添加
                        delete this.form.id;
                        const data = await createOutPerson(this.form);
                        if (data.data.success) {
                            if (data.data.success) {
                                this.$Message.success('添加成功');
                            } else {
                                this.$Message.error('添加失败');
                            }
                        }
                    } else {
                        //修改
                        // this.form.guid = this.id;
                        console.log(this.form);
                        const data = await updateOutPerson(this.form);
                        if (data.data.success) {
                            this.$Message.success('修改成功');
                        } else {
                            this.$Message.error('修改失败');
                        }
                    }
                    this.$emit('getTab');
                    this.$emit('close');
                    this.clearData();
                }
            });
        },
        clearData() {
            this.form = { name: '', companyName: '', phoneNumber: '', city: '', id: null };
            this.$refs['formValidate'].resetFields();
        },
        async getById() {
            const data = await getOutPersonById({ id: this.uid });
            this.form = { ...data.data.result };
        },
    },
    // watch只会监视isAdd  改变了isAdd的值才执行
    watch: {
        value: {
            handler(newV, oldV) {
                if (this.isAdd) {
                    this.clearData();
                } else {
                    if (this.uid) {
                        this.getById();
                    }
                }
            },
        },
    },
};
</script>

<style lang="less" scoped></style>
